import { render } from "./CmsMenu.vue?vue&type=template&id=19c017c9&scoped=true"
import script from "./CmsMenu.vue?vue&type=script&lang=js"
export * from "./CmsMenu.vue?vue&type=script&lang=js"

import "./CmsMenu.vue?vue&type=style&index=0&id=19c017c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c017c9"]])

export default __exports__